import { TdsDivider } from '@scania/tegel-react'
import styled from 'styled-components'

const TitleWrapper = styled.div`
  margin-top: 36px;
`

const Title = styled.h2.attrs({
  className: 'tds-headline-03'
})`
  margin-bottom: 16px;
`

const Description = styled.p.attrs({
  className: 'tds-body-01 sdds-text-negative'
})`
  opacity: 0.6;
  margin-top: 16px;
  margin-bottom: 36px;
`

const StyledDivider = styled(TdsDivider)<{ extraMargin: boolean }>`
  margin-bottom: 32px;
`

type PageHeaderProps = {
  title: string
  description?: string
}

export function PageHeader(props: PageHeaderProps): JSX.Element {
  const { description, title } = props

  return (
    <TitleWrapper>
      <Title>{title}</Title>
      <StyledDivider variant='discrete' extraMargin={!description} />
      {description && <Description>{description}</Description>}
    </TitleWrapper>
  )
}
